// extracted by mini-css-extract-plugin
export var cardTitle = "_ix-1";
export var commentBubble = "_ix-e";
export var commentForm = "_ix-a";
export var commentInput = "_ix-b";
export var commentLabel = "_ix-d";
export var commentPrompt = "_ix-9";
export var csatCard = "_ix-0";
export var feedbackSection = "_ix-7";
export var starDisabled = "_ix-6";
export var starEmpty = "_ix-5";
export var starFilled = "_ix-4";
export var starWrapper = "_ix-3";
export var starsContainer = "_ix-2";
export var submittedComment = "_ix-c";
export var thankYouText = "_ix-8";